module.exports = {
  title: 'chatmods',
  loading: 'loading...',
  workbench: {
    navigation: {
      chat: 'chat',
      games: 'games',
      winners: 'winners',
      settings: 'settings',
      playerNotes: 'player notes',
      search: 'search'
    },
    layout: {
      change: 'change window layout',
      arrange: 'arrange windows',
      tile: 'tile windows',
      minimise: 'minimise all windows',
      restore: 'restore all windows'
    },
    search: {
      searching: 'searching...',
      username: 'Username',
      chatRoom: 'Chat Room',
      noMatchingUsers: 'No matching users were found',
      gotoChatRoom: 'Go to chat room'
    }
  },
  userSettings: {
    rememberWindowLayout: 'Automatically save window layout',
    alertWords: {
      sectionTitle: 'Alert Words',
      resetButton: 'Reset',
      resetTitle: 'Reset Alert Words',
      resetMessage: 'Are you sure that you want to reset alert words?'
    },
    developer:{
      clearToggleCacheButton: 'Refresh Toggle Server Cache',
      clearToggleCacheTitle: 'Refresh Toggle Server Cache',
      clearToggleCacheMessage: 'Are you sure that you want to refresh the toggle server cache?',
    }
  },
  playerNotes: {
    tableHeaders: {
      actions: 'Actions',
      note: 'Note',
      createdBy: 'Created by',
      timestamp: 'Created date'
    },
    errors: {
      playerNotFound: 'Player could not be found. Please check the username and try again.' 
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/localisation/languages/nl/app.js
// module id = cyUx
// module chunks = 1